import { useState } from "react";
import { CalendarClock, ChevronDown } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ukDate } from "./crmPipelineShared";

const toISODate = (d) => {
  const off = d.getTimezoneOffset();
  return new Date(d.getTime() - off * 60000).toISOString().slice(0, 10);
};
const addDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return toISODate(d); };

// onSet receives an ISO date "YYYY-MM-DD" or null (to clear)
export function FollowUpControl({ value, onSet, compact = false, testIdPrefix = "followup" }) {
  const [calOpen, setCalOpen] = useState(false);
  const selected = value ? new Date(`${String(value).slice(0, 10)}T00:00:00`) : undefined;

  const QUICK = [
    ["Today", () => onSet(addDays(0))],
    ["Tomorrow", () => onSet(addDays(1))],
    ["+3 Days", () => onSet(addDays(3))],
    ["+1 Week", () => onSet(addDays(7))],
  ];

  const ChooseDate = (
    <Popover open={calOpen} onOpenChange={setCalOpen}>
      <PopoverTrigger asChild>
        <button data-testid={`${testIdPrefix}-choose-date`}
          className="flex items-center gap-1 text-[11px] bg-brass/15 hover:bg-brass/25 text-brass rounded-md px-2.5 py-1 border border-brass/30">
          <CalendarClock className="w-3 h-3" /> Choose Date <ChevronDown className="w-3 h-3" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#0B241B] border-white/10" align="start">
        <Calendar mode="single" selected={selected} defaultMonth={selected}
          onSelect={(d) => { if (d) { onSet(toISODate(d)); setCalOpen(false); } }}
          className="text-white" />
      </PopoverContent>
    </Popover>
  );

  if (compact) {
    return (
      <div className="flex items-center gap-1.5 flex-wrap" data-testid={`${testIdPrefix}-control`} onClick={(e) => e.stopPropagation()}>
        {ChooseDate}
        <button data-testid={`${testIdPrefix}-tomorrow`} onClick={() => onSet(addDays(1))} className="text-[11px] bg-white/5 hover:bg-white/15 text-emerald-100/80 rounded-md px-2 py-1">Tomorrow</button>
        <button data-testid={`${testIdPrefix}-1w`} onClick={() => onSet(addDays(7))} className="text-[11px] bg-white/5 hover:bg-white/15 text-emerald-100/80 rounded-md px-2 py-1">+1w</button>
        {value && <button data-testid={`${testIdPrefix}-clear`} onClick={() => onSet(null)} className="text-[11px] text-emerald-100/50 hover:text-white px-1.5 py-1">Clear</button>}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`${testIdPrefix}-control`}>
      <span className="text-xs text-emerald-100/50 flex items-center gap-1">
        <CalendarClock className="w-3.5 h-3.5" /> Next follow-up:
      </span>
      <span className="text-xs font-medium text-white bg-white/5 rounded-md px-2 py-1" data-testid={`${testIdPrefix}-current`}>{value ? ukDate(value) : "None set"}</span>
      {QUICK.map(([label, fn]) => (
        <button key={label} data-testid={`${testIdPrefix}-${label.toLowerCase().replace(/[^a-z0-9]/g, "")}`} onClick={fn}
          className="text-[11px] bg-white/5 hover:bg-white/15 text-emerald-100/80 rounded-md px-2.5 py-1">{label}</button>
      ))}
      {ChooseDate}
      {value && <button data-testid={`${testIdPrefix}-clear`} onClick={() => onSet(null)} className="text-[11px] text-emerald-100/50 hover:text-white px-2 py-1">Clear</button>}
    </div>
  );
}
